export const state = () => ({
  restaurants: [],
  menus: [],
  clients: [],
});

export const mutations = {
  setRestaurants(state, restaurants) {
    state.restaurants = restaurants;
  },
  setMenus(state, menus) {
    state.menus = menus;
  },
  setClients(state, clients) {
    state.clients = clients;
  },
};
